export enum SidebarTitleType {
  header = 'header',
  semiHeader = 'semiHeader',
  description = 'description'
}
